import { css } from "styled-components";
import { convertHexToRGBA, defaultThemeColors } from "ui/theme";

export const scrollbarStyles = css`
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: ${convertHexToRGBA(defaultThemeColors.lightBlue, 0.5)};
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: ${defaultThemeColors.blue15};
  }
`;
export const scrollbarStylesThin = css`
  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #F7F5F1;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: #CBCAC7;
  }
`;


export const hideScrollBar = css`
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none; /* for chrome, safari, and opera*/
  }
`;
